import React from 'react';
import { useSupport } from '../../context/SupportContext';
import styles from './AccountTeamPanel.module.css';

interface TeamMember {
  name: string;
  role: string;
  email: string;
  phone: string;
  avatar?: string;
}

interface AccountTeamPanelProps {
  teamMembers?: TeamMember[];
}

export const AccountTeamPanel: React.FC<AccountTeamPanelProps> = ({ teamMembers: propsMembers }) => {
  const { accountTeam: contextMembers, loading, refreshMetrics } = useSupport();
  const teamMembers = propsMembers || contextMembers;

  const getInitials = (name: string) => {
    if (!name) return '?';
    const parts = name.split(' ');
    return parts.map(p => p[0]).join('').toUpperCase();
  };

  const handleRefresh = (e: React.MouseEvent) => {
    e.preventDefault();
    refreshMetrics();
  };

  return (
    <div className={styles.accountTeamPanel}>
      <h3 className={styles.title}>Account Team</h3>
      <div className={styles.content}>
        {loading ? (
          <div className={styles.loadingState}>Loading team...</div>
        ) : teamMembers && teamMembers.length > 0 ? (
          teamMembers.map((member, index) => (
            <div key={index} className={styles.teamMember}>
              <div className={styles.avatar}>
                {member.avatar ? (
                  <img src={member.avatar} alt={member.name} />
                ) : (
                  <span>{getInitials(member.name)}</span>
                )}
              </div>
              <div className={styles.memberInfo}>
                <div className={styles.memberName}>{member.name}</div>
                <div className={styles.memberRole}>{member.role}</div>
                <div className={styles.memberContact}>
                  {member.email && (
                    <a href={`mailto:${member.email}`} className={styles.contactLink}>
                      {member.email}
                    </a>
                  )}
                  {member.phone && (
                    <a href={`tel:${member.phone}`} className={styles.contactLink}>
                      {member.phone}
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className={styles.emptyState}>
            <p>No account team found in CRM.</p>
            <button onClick={handleRefresh} className={styles.retryButton}>
              🔄 Check Again
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

